<template>
    <div class="comparator-items">
        <swiper class="comparItemsSwiper" ref="compareItemsSwiper" :options="swiperOptions"  >
            <swiper-slide v-for="(item, i) in cards" :key="i">
                <ConfigCard
                :checkboxField="'card' + i"
                :checkboxLabel="$parent.handleTitles(item)"
                :carSpecs="[item.fuel, item.transmission]"
                :carPrice="item.price"
                :checkBoxChecked="setFirstActCard(item.id)"
                :carID="item.id"
                :disabled="maxCompareItems(item.id)"
                :value.sync="passOnCarId"/>
            </swiper-slide>
        </swiper>

        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
    </div>
</template>
<script>
    import { mapState } from 'vuex';
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
    import SwiperCore, { Navigation, Pagination } from 'swiper';
    SwiperCore.use([Navigation, Pagination]);
    import 'swiper/swiper-bundle.css'
    import ConfigCard from '../../Cards/ConfigCard/ConfigCard.vue'

    export default {
        name: 'ComparatorItemsSwiper',
        components: { Swiper, SwiperSlide, ConfigCard },
        props:{
            currItems: {type: Array, default: () => { return []; }},
            cards: {type: Array, default: () => { return []; }},
            maxCI: {type: Number},
            isMotor: {type: Boolean, default: true},
        },
        directives: {
            swiper: directive
        },
        data(){return{
            passOnCarId: -1,
            swiperOptions: {
                slidesPerView: 3,
                spaceBetween: 25,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                breakpoints:{
                    0: { slidesPerView: 1.15 },
                    767: { slidesPerView: 2.2 },
                    992:{ slidesPerView: 3, spaceBetween: 25 }
                }
            },
        }},
        watch:{
            passOnCarId: function(val) {
                this.$emit('update:carID', val)
            }
        },
        computed: {
            ...mapState(['resumeData']),
            swiper(){
                return this.$refs.compareItemsSwiper.$swiper
            },
        },
        methods:{
            setFirstActCard(_id){
                let id = this.isMotor ? this.resumeData.selectedEngine : this.resumeData.versionID
                return _id === id ? true : false
            },
            maxCompareItems(id){
                if(this.currItems.length > this.maxCI){
                    return (this.currItems.includes(id)) ? false : true;
                }
            },
            getEngineTitle(item){
                if(item.power != 0) return item.engine + ' (' + item.power + ' CV)'
                if(item.powerKw != 0) return item.engine + ' (' + item.powerKw + ' Kw)'
                return item.engine
            },
        }
    }
</script>
<style lang="scss" scoped>
    .swiper-button-prev{ &:after{
        content: url(../../../assets/svg/leftChev.svg);
    }}
    .swiper-button-next{ transform: rotate(180deg);
        &:after{ content: url(../../../assets/svg/leftChev.svg);
    }}

    @include respond-to(maxLarge){
        .swiper-button-prev,
        .swiper-button-next{ display: none;}
    }
</style>